import V1DefaultConfigs from './V1DefaultConfigs.js';

export default V1DefaultConfigs;
